import * as React from "react";
import ReactDOM from "react-dom";
import Close from "./close";

const Modal = ({
  isOpen,
  onClose,
  children,
  variant = "default" | "booking",
  triggerRef,
}) => {
  const closeButtonRef = React.useRef(null);
  const [isClient, setIsClient] = React.useState(false);

  const handleClose = () => {
    onClose();
    triggerRef?.current?.focus();
  };

  React.useEffect(() => {
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      setTimeout(() => closeButtonRef.current?.focus(), 50);
    } else {
      document.body.removeAttribute("class");
    }
  }, [isOpen]);

  React.useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") handleClose();
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen]);

  React.useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null;
  }

  return ReactDOM.createPortal(
    <div
      className={`modal${isOpen ? " open" : ""}`}
      role={isOpen ? "dialog" : undefined}
      aria-modal={isOpen ? "true" : undefined}
      data-variant={variant}
      onClick={handleClose}
    >
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-close">
          <button
            type="button"
            onClick={handleClose}
            title="Fermer"
            ref={closeButtonRef}
          >
            <Close />
          </button>
        </div>
        {children}
      </div>
    </div>,
    document.body
  );
};

export default Modal;
